import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Zoom,
} from '@mui/material';
import * as React from 'react';
import { Question } from '../../types/questionnaire.types';

interface TrueFalseQuestionProps {
  question: Question;
  response: string;
  onResponseChange: (questionId: string, value: string) => void;
}

export const TrueFalseQuestion: React.FC<TrueFalseQuestionProps> = ({
  question,
  response,
  onResponseChange,
}) => {
  return (
    <FormControl component="fieldset" sx={{ width: '100%' }}>
      <RadioGroup
        value={response || ''}
        onChange={(e) => onResponseChange(question.id, e.target.value)}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            justifyContent: 'center',
            mb: 3,
          }}
        >
          {['true', 'false'].map((value, idx) => (
            <Zoom in timeout={400 + idx * 100} key={value}>
              <Box
                sx={{
                  flex: 1,
                  borderRadius: '12px',
                  border: '1px solid #F0F0F0',
                  borderColor:
                    response === value
                      ? value === 'true'
                        ? '#10b981'
                        : '#ef4444'
                      : '#e5e7eb',
                  background:
                    response === value
                      ? value === 'true'
                        ? 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)'
                        : 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)'
                      : '#ffffff',
                  '&:hover': {
                    borderColor: value === 'true' ? '#10b981' : '#ef4444',
                    boxShadow:
                      value === 'true'
                        ? '0 6px 20px rgba(16, 185, 129, 0.3)'
                        : '0 6px 20px rgba(239, 68, 68, 0.3)',
                  },
                }}
              >
                <FormControlLabel
                  value={value}
                  control={
                    <Radio
                      sx={{
                        visibility: 'hidden',
                      }}
                    />
                  }
                  label={
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                      }}
                    >
                      {response === value && (
                        <CheckCircleIcon
                          sx={{
                            display: 'none',
                            fontSize: '23px',
                          }}
                        />
                      )}
                      <Typography
                        sx={{
                          textAlign: 'center',
                          fontFamily: 'Roboto-Medium !important',
                          fontSize: '10.5pt !important',
                          color:
                            response === value
                              ? value === 'true'
                                ? '#10b981'
                                : '#ef4444'
                              : '#808080',
                        }}
                      >
                        {value === 'true' ? 'SIM' : 'NÃO'}
                      </Typography>
                    </Box>
                  }
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                />
              </Box>
            </Zoom>
          ))}
        </Box>
      </RadioGroup>
    </FormControl>
  );
};
